import * as React from "react";
import { AuthService } from "./configurations/AuthService";
import { Redirect } from "react-router-dom";

export default class SignIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      auth: false,
    };
    this.authService = new AuthService();
  }

  componentDidMount() {
    const self = this;
    this.authService
      .signinRedirectCallback()
      .then(function () {
        self.setState({ auth: true });
      })
      .catch(function (e) {
        console.error(e);
      });
  }

  render() {
    return (
      <>{this.state.auth ? <Redirect to="/signin" /> : <div>Sign In</div>}</>
    );
  }
}
